import type { SubscriptionRow } from "@/types";

type ProFields = Pick<SubscriptionRow, "is_pro" | "effective_pro">;

/**
 * Whether the user really has Pro right now. The API's effective_pro mirrors
 * hasActivePro: is_pro plus an unexpired period or grace period. Falls back to
 * is_pro for responses from before effective_pro existed.
 */
export function isEffectivePro(row: ProFields): boolean {
  return row.effective_pro ?? row.is_pro;
}

/** is_pro is still set, but the period has expired (a missed webhook). */
export function isStalePro(row: ProFields): boolean {
  return row.is_pro && row.effective_pro === false;
}
